import { Component, ViewContainerRef } from '@angular/core';
import { JsonApiService } from './core/api/json-api.service';

declare var $: any;

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent {
    public title = 'app works!';

    public constructor(private viewContainerRef: ViewContainerRef,
        private jsonApiService: JsonApiService) {

        sessionStorage.setItem('sm-fixed-header', 'true');
        sessionStorage.setItem('defaultLocale', 'es');
        Promise.all([
            this.obtenerI18n(),
            System.import('script-loader!smartadmin-plugins/datatables/datatables.min.js'),
        ]).then(() => {
            $.fn.dataTable.ext.errMode = 'none';
        });
        $.get('assets/plugins/gritter/js/jquery.gritter.js', undefined, null, 'script').done(function () {
        });
    }

    private obtenerI18n() {/*
        let  path = localStorage.getItem('rutaServidor');

        console.log("path " ,path)
        if(path == null){
            let  i18n = sessionStorage.getItem('defaultLocale');
            i18n = navigator.language.substr(0,2) ;
            console.log("i18n : ", i18n);
            if (i18n === 'es') {
                console.log("español : ", i18n);
                this.jsonApiService.fetch('/langs/es.json')
                    .subscribe(data => {
                        const datai18n = JSON.stringify(data);
                        localStorage.setItem('datai18n', datai18n);
                    })
                    ;
            } else {
                console.log("otro: ", i18n);
                this.jsonApiService.fetch('/langs/us.json')
                    .subscribe(data => {
                        const datai18n = JSON.stringify(data);
                         localStorage.setItem('datai18n', datai18n);
                    });
            }
        }*/
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts